// 单文件引入方式

import ZuiPopupSelector from './ZuiPopupSelector.vue'

export default {
  install(Vue) {
    Vue.component('ZuiPopupSelector', ZuiPopupSelector)
  }
}
